module.exports = __webpack_public_path__ + "static/media/hcp-scpharma-logo.52c65992.svg";